"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExData = void 0;
var KeyPair_1 = require("../../account/KeyPair");
var Bytes_1 = require("../../Bytes");
var DataWriter_1 = require("../../DataWriter");
var Base58_1 = require("../../../../crypt/libs/Base58");
var AppCrypt_1 = require("../../../../crypt/AppCrypt");
var aesCrypt_1 = require("../../../../crypt/libs/aesCrypt");
var ExLink_1 = require("./ExLink");
var ExData = /** @class */ (function () {
    function ExData(keys, title, data, encrypted, exLink, onlyRecipients) {
        if (onlyRecipients === void 0) { onlyRecipients = false; }
        this.keys = keys;
        this.flags = new Int8Array([3, encrypted ? 32 : (exLink ? -128 : 0), 0, 0]);
        this.title = title;
        this.data = data;
        this.recipientFlags = onlyRecipients ? new Int8Array([-128]) : new Int8Array([0]);
        this.recipients = [];
        this.secretFlags = new Int8Array([0]);
        this.secrets = [];
        this.publics = [];
        this.shareKeys = new KeyPair_1.KeyPair();
        this.exLink = exLink;
    }
    ExData.prototype.password32 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this._password32) return [3 /*break*/, 2];
                        _a = this;
                        _b = Int8Array.bind;
                        return [4 /*yield*/, aesCrypt_1.getPassword(this.shareKeys.publicKey, this.shareKeys.secretKey)];
                    case 1:
                        _a._password32 = new (_b.apply(Int8Array, [void 0, _c.sent()]))();
                        _c.label = 2;
                    case 2: return [2 /*return*/, this._password32];
                }
            });
        });
    };
    ExData.prototype.addRecipient = function (recipient) {
        return __awaiter(this, void 0, void 0, function () {
            var addressOrPublic, _a, length, address, short, secret, sharedKey, encryptedSecret, l, short;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof recipient === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipient)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = recipient;
                        _b.label = 3;
                    case 3:
                        addressOrPublic = _a;
                        length = addressOrPublic.length;
                        if (this.flags[1] === 32 && length !== 32) {
                            throw new Error('Not public key');
                        }
                        if (!(length === 32)) return [3 /*break*/, 9];
                        this.publics.push(addressOrPublic);
                        return [4 /*yield*/, AppCrypt_1.AppCrypt.getAddressByPublicKey(addressOrPublic)];
                    case 4:
                        address = _b.sent();
                        return [4 /*yield*/, AppCrypt_1.AppCrypt.shortAddress(address)];
                    case 5:
                        short = _b.sent();
                        this.recipients.push(short);
                        return [4 /*yield*/, this.password32()];
                    case 6:
                        secret = _b.sent();
                        return [4 /*yield*/, aesCrypt_1.passwordAES(addressOrPublic, this.keys.secretKey)];
                    case 7:
                        sharedKey = _b.sent();
                        return [4 /*yield*/, aesCrypt_1.encryptBytes(secret, sharedKey)];
                    case 8:
                        encryptedSecret = _b.sent();
                        l = new Int8Array([0]);
                        l[0] = encryptedSecret.length;
                        this.secrets.push(new Int8Array(__spread([l[0]], encryptedSecret)));
                        return [3 /*break*/, 11];
                    case 9: return [4 /*yield*/, AppCrypt_1.AppCrypt.shortAddress(addressOrPublic)];
                    case 10:
                        short = _b.sent();
                        this.recipients.push(short);
                        _b.label = 11;
                    case 11:
                        this.flags[1] = this.flags[1] | 64;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.prototype.addAuthor = function (id, weight, desc) {
        if (weight < 0 || weight > 1000) {
            throw new Error("The weight must be in the range from 0 to 1000");
        }
        var exLink = new ExLink_1.ExLink(ExLink_1.ExLink.TYPE_AUTHOR, id.toString(), 0, weight, 0, desc);
        if (!this.authors) {
            this.authors = [];
        }
        this.authors.push(exLink);
        this.flags[1] = this.flags[1] | 16;
    };
    ExData.prototype.addSource = function (seqNo, weight, desc) {
        if (weight < 0 || weight > 1000) {
            throw new Error("The weight must be in the range from 0 to 1000");
        }
        var exLink = new ExLink_1.ExLink(ExLink_1.ExLink.TYPE_SOURCE, seqNo, 0, weight, 0, desc);
        if (!this.sources) {
            this.sources = [];
        }
        this.sources.push(exLink);
        this.flags[1] = this.flags[1] | 8;
    };
    ExData.prototype.addTags = function (tags) {
        this.tags = tags;
        this.flags[1] = this.flags[1] | 4;
    };
    ExData.prototype.selfShortAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AppCrypt_1.AppCrypt.getAddressByPublicKey(this.keys.publicKey)];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, AppCrypt_1.AppCrypt.shortAddress(address)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ExData.prototype.linkToBytes = function (link, dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.longToByteArray(link)];
                    case 1:
                        bytes = _a.sent();
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.prototype.toBytes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, i, recipient, i, exLink, weight, memo, i, exLink, weight, memo, tags, i, bytes, secret, sharedKey, encryptedSecret, l, bytesData, secret, sharedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        //console.log("exData.flags.toBytes", this.flags);
                        data.set(this.flags);
                        return [4 /*yield*/, this.stringToBytes(this.title, data, true)];
                    case 1:
                        _a.sent();
                        if (!(this.flags[1] < 0)) return [3 /*break*/, 3];
                        if (!this.exLink) {
                            throw new Error("The 'exLink' parameter not found");
                        }
                        data.setNumber(this.exLink.type);
                        data.setNumber(this.exLink.flags);
                        data.setNumber(this.exLink.value_1);
                        data.setNumber(this.exLink.value_2);
                        return [4 /*yield*/, this.linkToBytes(this.exLink.link, data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!((this.flags[1] & 64) === 64)) return [3 /*break*/, 5];
                        data.set(this.recipientFlags);
                        return [4 /*yield*/, this.recipientsLengthToBytes(data)];
                    case 4:
                        _a.sent();
                        // tslint:disable-next-line: prefer-for-of
                        for (i = 0; i < this.recipients.length; i += 1) {
                            recipient = this.recipients[i];
                            data.set(recipient);
                        }
                        _a.label = 5;
                    case 5:
                        if (!this.authors) return [3 /*break*/, 12];
                        data.setNumber(0); // AUTHORS FLAGS
                        return [4 /*yield*/, this.authorsLengthToBytes(data)];
                    case 6:
                        _a.sent();
                        i = 0;
                        _a.label = 7;
                    case 7:
                        if (!(i < this.authors.length)) return [3 /*break*/, 12];
                        exLink = this.authors[i];
                        data.setNumber(exLink.type);
                        data.setNumber(exLink.flags);
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray2(exLink.value_1)];
                    case 8:
                        weight = _a.sent();
                        data.set(weight);
                        return [4 /*yield*/, this.linkToBytes(exLink.link, data)];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(exLink.memo)];
                    case 10:
                        memo = _a.sent();
                        data.setNumber(memo.length);
                        data.set(memo);
                        _a.label = 11;
                    case 11:
                        i += 1;
                        return [3 /*break*/, 7];
                    case 12:
                        if (!this.sources) return [3 /*break*/, 19];
                        data.setNumber(0); // SOURCES FLAGS
                        return [4 /*yield*/, this.sourcesLengthToBytes(data)];
                    case 13:
                        _a.sent();
                        i = 0;
                        _a.label = 14;
                    case 14:
                        if (!(i < this.sources.length)) return [3 /*break*/, 19];
                        exLink = this.sources[i];
                        data.setNumber(exLink.type);
                        data.setNumber(exLink.flags);
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray2(exLink.value_1)];
                    case 15:
                        weight = _a.sent();
                        data.set(weight);
                        return [4 /*yield*/, this.linkToBytes(exLink.link, data)];
                    case 16:
                        _a.sent();
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(exLink.memo)];
                    case 17:
                        memo = _a.sent();
                        data.setNumber(memo.length);
                        data.set(memo);
                        _a.label = 18;
                    case 18:
                        i += 1;
                        return [3 /*break*/, 14];
                    case 19:
                        if (!this.tags) return [3 /*break*/, 21];
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.tags.join(","))];
                    case 20:
                        tags = _a.sent();
                        data.setNumber(tags.length);
                        data.set(tags);
                        _a.label = 21;
                    case 21:
                        if (!((this.flags[1] & 32) === 32)) return [3 /*break*/, 25];
                        data.set(this.secretFlags);
                        // tslint:disable-next-line: prefer-for-of
                        for (i = 0; i < this.secrets.length; i += 1) {
                            bytes = this.secrets[i];
                            data.set(bytes);
                        }
                        return [4 /*yield*/, this.password32()];
                    case 22:
                        secret = _a.sent();
                        return [4 /*yield*/, aesCrypt_1.passwordAES(this.keys.publicKey, this.keys.secretKey)];
                    case 23:
                        sharedKey = _a.sent();
                        return [4 /*yield*/, aesCrypt_1.encryptBytes(secret, sharedKey)];
                    case 24:
                        encryptedSecret = _a.sent();
                        l = new Int8Array([0]);
                        l[0] = encryptedSecret.length;
                        data.set(new Int8Array(__spread([l[0]], encryptedSecret)));
                        _a.label = 25;
                    case 25: return [4 /*yield*/, this.data.toBytes()];
                    case 26:
                        bytesData = _a.sent();
                        if (!((this.flags[1] & 32) === 32)) return [3 /*break*/, 29];
                        return [4 /*yield*/, this.password32()];
                    case 27:
                        secret = _a.sent();
                        sharedKey = aesCrypt_1.bytesToWords(secret);
                        return [4 /*yield*/, aesCrypt_1.encryptBytes(bytesData, sharedKey, false)];
                    case 28:
                        bytesData = _a.sent();
                        _a.label = 29;
                    case 29:
                        data.set(bytesData);
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    ExData.prototype.recipientsLengthToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var lengthBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.intToByteArray3(this.recipients.length)];
                    case 1:
                        lengthBytes = _a.sent();
                        dataWriter.set(lengthBytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.prototype.authorsLengthToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var lengthBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.intToByteArray3(this.authors.length)];
                    case 1:
                        lengthBytes = _a.sent();
                        dataWriter.set(lengthBytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.prototype.sourcesLengthToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var lengthBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.intToByteArray3(this.sources.length)];
                    case 1:
                        lengthBytes = _a.sent();
                        dataWriter.set(lengthBytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.prototype.stringToBytes = function (str, dataWriter, preLength) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes, lengthBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(str)];
                    case 1:
                        bytes = _a.sent();
                        if (preLength) {
                            lengthBytes = new Int8Array([0]);
                            lengthBytes[0] = bytes.length;
                            dataWriter.set(lengthBytes);
                        }
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExData.RECIPIENTS_LENGTH_SIZE = 3;
    return ExData;
}());
exports.ExData = ExData;
